import React from "react";
import "./portfolio.css";
import IMG1 from "../../assets/brights-lite.png";
import IMG2 from "../../assets/blog.png";
import IMG3 from "../../assets/calculator.png";
import IMG4 from "../../assets/brochure.png";
import IMG5 from "../../assets/Portfolio3.png";
import IMG6 from "../../assets/Portfolio4.png";

const data = [
  {
    id: 1,
    image: IMG1,
    title: "ALGORITHM-VISUALIZER",
    github: "https://github.com/SaiSriramKamineni/ALGORITHM-VISUALIZER",
    demo: "https://saisriramkamineni.github.io/ALGORITHM-VISUALIZER/",
   brief:
      "*readmefilepetiali*",
  },
  {
    id: 2,
    image: IMG2,
    title: "HEYBOT Voice Assistant",
    github: "https://github.com/SaiSriramKamineni/HEY-BOT-Voice-Assistant",
    brief: "https://github.com/SaiSriramKamineni/HEY-BOT-Voice-Assistant/blob/main/readme.md",
    demo: "https://drive.google.com/file/d/1YY_2xHu0fmv1gS2wwnHm439GZ86JNB6l/view?usp=sharing",
  },
  {
    id: 3,
    image: IMG3,
    title: "Banking Management System",
    github: "https://github.com/SaiSriramKamineni/Banking-management-system",
    demo: "https://github.com/SaiSriramKamineni/Banking-management-system/blob/main/Banking-management-system.cpp",
    brief:
      "https://github.com/SaiSriramKamineni/Banking-management-system/blob/main/readme.md",
  },
  {
    id: 4,
    image: IMG4,
    title: "Scientific Calculator-GUI",
    github: "https://github.com/SaiSriramKamineni/ScientificCalculator-GUI",
    demo: "https://github.com/SaiSriramKamineni/ScientificCalculator-GUI/blob/main/ScientifiCalculator.py",
    brief: "https://github.com/SaiSriramKamineni/ScientificCalculator-GUI/blob/main/readme.md",
  },
  {
    id: 5,
    image: IMG5,
    title: "N-Queens Visualiser ",
    github: "https://github.com/SaiSriramKamineni/N-Queen-Visualizer",
    demo: "https://saisriramkamineni.github.io/N-Queen-Visualizer/",
    brief: "https://github.com/SaiSriramKamineni/N-Queen-Visualizer/blob/main/README.md",
  },
  {
    id: 6,
    image: IMG6,
    title: "Typing Speed Test Application",
    github: "https://github.com/SaiSriramKamineni/Typing-Speed-Test-Application-Python-GUI",
    demo: "https://github.com/SaiSriramKamineni/Typing-Speed-Test-Application-Python-GUI/blob/main/type.py",
    brief: "https://github.com/SaiSriramKamineni/Typing-Speed-Test-Application-Python-GUI/blob/main/readme.md",
      },
];

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My most recent work can be found on YouTube</h5>
      <h2>Portfolio</h2>
      <h5>There are live demos for certain projects and complier-based demos that are recorded during runtime for others. </h5>
      <h5>And few live demos that link to their source code</h5>
      <div className="container portfolio__container">
        {data.map(({ id, image, title, github, demo, brief }) => {
          return (
            <article key={id} className="portfolio__item">
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <div className="portfolio__item-cta">
                <a href={github} className="btn">
                  Github
                </a>
                <a href={brief} className="btn">
                  Project Brief
                </a>
              </div>
              <div className="portfolio__item-cta">
                <a href={demo} className="btn btn-primary">
                  Live Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Portfolio;
